import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog'

export interface ConfirmationDialogData {
	titleText?: string
	dialogText: string
	noText?: string
	yesText?: string
}

@Component({
	selector: 'app-confirmation-dialog',
	imports: [MatButtonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose],
	templateUrl: './confirmation-dialog.html',
	styleUrl: './confirmation-dialog.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialog {
	protected readonly data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA)
}
